import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { makeStyles } from "@material-ui/styles";
import CardTitle from "@saleor/components/CardTitle";
import Clipboard from "@saleor/components/Clipboard";
import React from "react";

const useStyles = makeStyles(
  () => ({
    card: {
      width: "35%"
    },
    titleBar: {
      "& span": {
        lineBreak: "anywhere",
        flex: "none",
        width: "-webkit-fill-available"
      }
    }
  }),
  { name: "BannerDateTime" }
);

export interface DeepLinkProps {
  linkId: string;
  linkUrl: string;
  shortLinkUrl: string;
  onGenerateDeeplink: (id: string) => void;
}

const DeepLink: React.FC<DeepLinkProps> = ({
  linkId,
  linkUrl,
  shortLinkUrl,
  onGenerateDeeplink
}) => {
  const classes = useStyles({});

  return (
    <Card className={classes.card}>
      <CardTitle title="Deeplink details" className={classes.titleBar} />
      <CardContent>
        <Clipboard
          idClipboard="bannerID"
          label="Banner Id"
          value={linkId}
          onGenerate={() => undefined}
        />
        <Clipboard
          idClipboard="deeplinkURL"
          label="Deeplink URL"
          value={linkUrl}
          onGenerate={() => onGenerateDeeplink(linkId)}
        />
        <Clipboard
          idClipboard="shortDynamicURL"
          label="Short Dynamic URL"
          value={shortLinkUrl}
          onGenerate={() => onGenerateDeeplink(linkId)}
        />
      </CardContent>
    </Card>
  );
};

export default DeepLink;
